module.exports = __webpack_public_path__ + "img/Weapon_166.223ed24a.png";